import { all, put, takeEvery } from 'redux-saga/effects'
import { ADD_NOTIFICATION, AddNotificationAction } from '../actions/notification'
import { showDesktopNotification, isNotificationEnabled } from '../util/browserNotification'

export function* notificationSaga(): Generator<any, any, any> {
  yield all([
    takeEvery(ADD_NOTIFICATION, addDesktopNotificationSaga)
  ])
}

export function* addDesktopNotificationSaga(action: AddNotificationAction): Generator<any, any, any> {
  const notification = action.notification

  // Show desktop notification if enabled
  if (!isNotificationEnabled()) {
    return
  }

  showDesktopNotification(notification)
}
